import { isMobileApp } from '@/utils/apps';
import {
    BuildingBlockLayouts,
    BuildingBlockProperties,
    BuildingBlockRichTextConverter,
} from '@pendo/services/BuildingBlocks';
const { widgetIds } = BuildingBlockLayouts;

export function getTextBlockTextFromEvent ({ event, turndownService }) {
    const {
        data: { dom },
    } = event;
    const markdownText = turndownService.turndown(dom);

    return markdownText;
}

export function getButtonBlockTextFromEvent ({ event }) {
    const {
        data: { dom },
    } = event;

    return dom.innerText;
}

export function getBlockContent ({ type, event, turndownService }) {
    switch (type) {
        case 'text':
            return getTextBlockTextFromEvent({ event, turndownService });
        case 'button':
            return getButtonBlockTextFromEvent({ event });
    }
}

export function setBlockContent ({ buildingBlock, content, platform }) {
    switch (buildingBlock.widget) {
        case widgetIds.textViewBlock:
            setTextBlockContent({ buildingBlock, content, platform });
            break;
        case widgetIds.buttonBlock:
            setButtonBlockContent({ buildingBlock, text: content });
            break;
    }
}

export function setTextBlockContent ({ buildingBlock, content, platform }) {
    if (isMobileApp(platform)) {
        BuildingBlockProperties.updateOrCreateProperty(buildingBlock, 'text', 'string', content);

        return;
    }

    BuildingBlockProperties.updateOrCreateProperty(buildingBlock, 'markdownText', 'string', content);
    buildingBlock.views = [BuildingBlockRichTextConverter.parseMarkdownToBuildingBlocks(content, buildingBlock)];
}

export function setButtonBlockContent ({ buildingBlock, text }) {
    BuildingBlockProperties.updateOrCreateProperty(buildingBlock, 'text', 'string', text);
}

export function getStepIndexById (id, steps) {
    return steps.findIndex((step) => step.id === id);
}
